import { gql } from '@apollo/client';

export const LIST_CHATS = gql`
  query ListChats($filter: ChatFilterInput!) {
    listChats(filter: $filter) {
      items {
        id
        case_id
        name
        created_date
      }
    }
  }
`;
